import Vue from 'vue';
import jQuery from 'jquery';
import BootstrapVue from 'bootstrap-vue';
import { CalendarPlugin } from 'bootstrap-vue'
import axios from 'axios';
import router from './router';
import routes from './router/routeNames'
import Vuex from 'vuex';
import store from './store';
import App from './App.vue';
import './filters/dateFormat.js';
import AuthService from './services/AuthService';

global.jQuery = jQuery;

Vue.config.productionTip = true;
Vue.config.devtools = process.env.NODE_ENV === 'development'

Vue.use(CalendarPlugin)
Vue.use(BootstrapVue);

Array.prototype.unique = function () {
  return this.filter(function (value, index, self) {
    return self.indexOf(value) === index;
  });
}

function renderFailed() {
  const store2 = new Vuex.Store();
  const app = new Vue({
    router,
    store2,
    computed: {
    },
    BootstrapVue,
    render: h => h(App)
  });
  window.grandFail = true;
  app.$mount('#app');
}
function removeLoadingElement() {
  const loadingEl = document.getElementById("loading");
  loadingEl.parentElement.removeChild(loadingEl);
}

axios.defaults.timeout = 5000;
axios.get('/api/api/constants/getConstants').then(res => {
  try {
    axios.defaults.timeout = 10000;

    const data = res.data.b2c;

    const ClientId = data.b2CClientId;
    const Signup = `https://${data.b2CInstance}/tfp/${data.b2CTenant}/${data.policies.b2CSignUpPolicy}`;
    const Signin = `https://${data.b2CInstance}/tfp/${data.b2CTenant}/${data.policies.b2CSignUpSignInPolicy}`;
    const Redirect = data.redirects.b2CLoginRedirect;
    const RedirectLogout = data.redirects.b2CLogoutRedirect;
    const RedirectUserProfile = data.redirects.b2CUserProfileUri;

    window.$authservice = new AuthService(ClientId, Signin, Signup, Redirect, RedirectLogout);

    const user = window.$authservice.getUser();
    if(user && user.idToken.tfp == "B2C_1_password_reset") {
      return window.$authservice.loginWithRedir();
    }

    const urls = res.data.urls;
    const appData = res.data.appData;

    removeLoadingElement();

    const appEl = document.getElementById("app");
    appEl.classList.remove("hidden");

    const app = new Vue({
      router,
      store,
      async created() {       
        this.$store.commit('setUserProfileUri', RedirectUserProfile);
        this.$store.commit('setVarsomUrl', urls.varsomUrl);
        this.$store.commit('setMetUrl', urls.metUrl);

        this.$store.commit('setAvalancheRegions', appData.avalancheRegions);
        this.$store.commit('setMunicipalities', appData.councils);
        this.$store.commit('setCounties', appData.counties);
        this.$store.commit('setRockslideObjects', appData.rockslideObjects);
        this.$store.commit('setSubscriptionTypes', appData.subscriptionTypes);

        await this.$store.dispatch('initApplicationData');
        await this.$store.dispatch('auth/checklogin');
        this.$store.commit('setIsInitialized', true);
        if (this.$store.getters.userLoggedIn && this.$store.getters.user) {
          if (!this.$router.currentRoute.path.startsWith(routes.getPathForRoute(routes.Varsler))) {
            this.$router.push({ path: "/Varsler" });
          }
        }
      },
      BootstrapVue,
      render: h => h(App)
    });
    window.grandFail = false;
    app.$mount('#app');
  }
  catch (err) {
    // eslint-disable-next-line
    console.error(`Unable to initialize application. Error (${err.message}) `, err);
    removeLoadingElement();
    renderFailed();
  }
}, () => {
  removeLoadingElement();
  renderFailed();
});
